import { render } from "./Navbar.vue?vue&type=template&id=95665260&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=95665260&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95665260"]])

export default __exports__